import routerOptions0 from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}